import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch } from '../../lib/reduxHooks';
import { useAutomaticFontSizing } from '../../lib/useAutomaticFontSizing';
import useDebounce from '../../lib/useDebounce';
import * as actions from '../../store/senderBuild/actions';

interface IProps {
  blockId: string;
  value?: string;
  fontSize?: number;
  height: number;
  width: number;
  updateBlock: (updates: any) => void;
  zoom: number;
  isCreating: boolean;
}

// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
const TextBox = (props: IProps) => {
  const dispatch = useDispatch();
  const { fontSize, value, setValue } = useAutomaticFontSizing({
    height: props.height,
    width: props.width,
    zoom: props.zoom,
    initialFontSize: props.fontSize,
    initialValue: props.value,
  });
  const { blockId } = props;
  const debouncedFontsize = useDebounce(fontSize, 50);
  const debouncedValue = useDebounce(value, 50);
  const firstRender = React.useRef(true);

  // Reset the value whenever a different block is selected
  React.useEffect(() => {
    setValue(props.value!);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [blockId]);

  React.useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    if ((props.fontSize !== fontSize || props.value !== value) && !props.isCreating) {
      props.updateBlock({ fontSize, value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [debouncedFontsize, debouncedValue]);

  React.useEffect(() => {
    // @ts-expect-error -- This code was written prior to enforcing lint rules
    setValue(props.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, [props.value]);

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onType = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onFocus = () => dispatch(actions.focusInput());

  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const onBlur = () => dispatch(actions.blurInput());
  return (
    <TextField
      style={{ margin: 0 }}
      variant="filled"
      margin="none"
      onChange={onType}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value || ''}
      rowsMax={10}
      fullWidth
      multiline
      inputProps={{
        onKeyUp: (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
          // prevent backspace from deleting
          e.preventDefault();
          e.stopPropagation();
          e.nativeEvent.stopImmediatePropagation();
        },
      }}
      id="textFieldInput"
    />
  );
};

// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default TextBox;
